import type { AgentBackupData } from '@shared/api';
import type { AgentBackupItem } from './types';

export const AGENT_BACKUP_NAME_MAX_LENGTH = 120;

type AgentBackupDataWithOwner = AgentBackupData & {
  owner_name?: string | null;
};

export const mapAgentBackupToItem = (
  backup: AgentBackupDataWithOwner,
  fallbackAuthor: string,
): AgentBackupItem => ({
  id: backup.id,
  title: backup.name,
  author: backup.owner_name?.trim() || fallbackAuthor,
  createdAt: backup.created_at,
});
